import { createContext } from 'react'

/** Null only outside the application provider (isolated component consumers). */
export const OperationDateContext = createContext<{ date?: string; unavailable: boolean } | null>(null)
